import {ApolloClient, InMemoryCache} from '@apollo/client';

import {apolloConfigFn, ApolloConfig, Context} from './apollo-config-fn';

export let apolloClient: ApolloClient | null = null;

const isBrowser = typeof window !== 'undefined';

const createDefaultCache = () => new InMemoryCache();

function create({createCache, ...apolloConfig}: ApolloConfig, initialState: any) {
	const c = createCache || createDefaultCache;

	const config: ApolloClient.Options = {
		devtools: {enabled: isBrowser},
		ssrMode: !isBrowser, // Disables forceFetch on the server (so queries are only run once)
		cache: c().restore(initialState || {}),
		...apolloConfig,
		defaultOptions: {
			mutate: {
				errorPolicy: 'all',
			},
			query: {
				errorPolicy: 'all',
			},
			watchQuery: {
				// в v4 значение по умолчанию стало true, из-за чего лоадеры мигают на каждом refetch
				notifyOnNetworkStatusChange: false,
			},
		},
	};

	return new ApolloClient(config);
}

export function initApollo(initialState: any, ctx?: Context | null) {
	const apolloConfig = apolloConfigFn(ctx);

	if (!isBrowser) {
		return create(apolloConfig, initialState);
	}

	// Reuse client on the client-side
	if (!apolloClient) {
		apolloClient = create(apolloConfig, initialState);
	}

	return apolloClient;
}
